import { render, staticRenderFns } from "./VariationsList.vue?vue&type=template&id=6453143a"
import script from "./VariationsList.vue?vue&type=script&lang=js"
export * from "./VariationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports